import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { CheckoutDeliveryStatusComponentDef } from '@df/checkout/checkout-delivery-status.component.def';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { Events } from '@df/core/service/event';
import { ToAddressPipeService } from '@df/ui/common/to-address.pipe';
import { merge } from 'rxjs/internal/observable/merge';
import { Subscription } from 'rxjs/internal/Subscription';
import { CheckoutAddressModelComponent } from './checkout-address-model.component';
import { CHECKOUT_STEPS_NAMES, CheckoutFormComponent } from './checkout-form.component';
import { CheckoutCollectionStatusComponent } from './collection/checkout-collection-status.component';

@Component({
    selector: 'checkout-delivery-status',
    templateUrl: './checkout-delivery-status.component.html',
    standalone: true,
    imports: [CheckoutAddressModelComponent, CheckoutCollectionStatusComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutDeliveryStatusComponent extends CheckoutDeliveryStatusComponentDef implements OnInit {
    private events = inject(Events);
    protected subscriptions = new Subscription();

    constructor(
        public override checkoutFormComponent: CheckoutFormComponent,
        toAddressPipe: ToAddressPipeService,
        app: App,
        protected changeDetectorRef: ChangeDetectorRef
    ) {
        super(checkoutFormComponent, toAddressPipe, app);
    }

    ngOnInit(): void {
        this.subscriptions.add(
            merge(this.customer.model.obs.status, this.events.on(Checkout.EVENTS.StepChange)).subscribe(() =>
                this.changeDetectorRef.detectChanges()
            )
        );
    }

    get isShipping(): boolean {
        return this.checkoutFormComponent.isShipping;
    }

    get isCollection(): boolean {
        return this.checkoutFormComponent.isCollection;
    }

    get displayAddress() {
        if (this.isShipping) {
            const addressStep = this.checkoutFormComponent.getStepByName(CHECKOUT_STEPS_NAMES['deliveryAddress']);
            return !!(addressStep && addressStep.valid && !addressStep.isCurrent);
        }
        return false;
    }

    get displayCollection() {
        if (this.isCollection) {
            const collectionStep = this.checkoutFormComponent.getStepByName(CHECKOUT_STEPS_NAMES['collection']);
            return !!(collectionStep?.valid && !collectionStep.isCurrent);
        }
        return false;
    }
}
